import type { RefObject } from 'react';
import { useRef } from 'react';

type Refs = {
	loadMoreRef: RefObject<null>;
	loadingRef: RefObject<null>;
	itemRef: RefObject<null>;
	lastItemRef: RefObject<null>;
};

export function useLazyLoadedListFocusRefs(): Refs {
	const loadingRef = useRef(null);
	const loadMoreRef = useRef(null);

	const itemRef = useRef(null);
	const lastItemRef = useRef(null);

	return {
		loadMoreRef,
		loadingRef,
		itemRef,
		lastItemRef,
	};
}
